import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Sgke041aResponseResponseBusinessArea } from 'sg-api';

/**
 * 振替登録画面_検索結果
 * @export
 * @class Sgke040dSearchResultComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 * @implements {AfterViewInit}
 */
@Component({
  selector: 'app-sgke040d-search-result',
  templateUrl: './sgke040d-search-result.component.html',
  styleUrl: './sgke040d-search-result.component.scss'
})
export class Sgke040dSearchResultComponent implements OnInit, OnDestroy {

  /** 登録ボタン押下エミッター */
  @Output() registEmit = new EventEmitter();

  /** 検索結果リスト */
  @Input() searchResultList: Array<Sgke041aResponseResponseBusinessArea>;

  /** データソース */
  dataSource: MatTableDataSource<Sgke041aResponseResponseBusinessArea>;
  /** 契約情報テーブル選択情報 */
  selection = new SelectionModel<Sgke041aResponseResponseBusinessArea>(false, []);
  /** 請求お客さま番号 */
  recptFixNo: string = "";

  /** 登録時のご請求先検索結果テーブル表示データ */
  displaySearchedColumns: string[] = [
    'select',
    'recptFixNo',
    'visitName',
    'telNo',
    'sazvjjsKanjiAname',
  ];

  /**
   * コンストラクタ
   * @memberof Sgke040dSearchResultComponent
   */
  constructor() { }

  /**
   * 初期処理
   * @memberof Sgke040dSearchResultComponent
   */
  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<Sgke041aResponseResponseBusinessArea>(this.searchResultList);
    this.recptFixNo = this.searchResultList[0].visitornumber;
  }

  /**
   * 終了処理
   * @memberof Sgke040dSearchResultComponent
   */
  ngOnDestroy() {
  }

  /**
   * 登録ボタン押下時処理
   * @memberof Sgke040dSearchResultComponent
   */
  onClickRegist() {
    // 請求お客さま番号
    this.registEmit.emit(this.recptFixNo)
  }
}